import { axios } from 'shared/services/axios'

export function updateItemPosition({ categoryId, itemId, position }) {
  return axios.put(
    `/api/v1/positioning/items/${itemId}`, {
      category_id: categoryId,
      position
    })
    .then(response => response.data)
}

export function updateCategoryPosition({ categoryId, position }) {
  return axios.put(
    `/api/v1/positioning/categories/${categoryId}`, {
      position
    })
    .then(response => response.data)
}